import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Home, List, Calculator, MessageSquare, Settings, ChevronLeft, ChevronRight, User, Activity, Mail, Share2 } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { isAdminUser } from '../helpers/accessControl'

const Sidebar = ({ collapsed, onToggleCollapse }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()

  const navigationItems = [
    {
      name: 'Domů',
      icon: Home,
      path: '/dashboard',
      active: location.pathname === '/' || location.pathname.startsWith('/dashboard'),
    },
    {
      name: 'Inzeráty',
      icon: List,
      path: '/listings',
      active: location.pathname.startsWith('/listings'),
    },
    {
      name: 'Odhady',
      icon: Calculator,
      path: '/valuations',
      active: location.pathname.startsWith('/valuations'),
    },
    {
      name: 'Market AI',
      icon: MessageSquare,
      path: '/ai',
      active: location.pathname.startsWith('/ai'),
    },
    {
      name: 'Scheduler',
      icon: Activity,
      path: '/scheduler',
      active: location.pathname.startsWith('/scheduler'),
      adminOnly: true,
    },
    {
      name: 'Outreach',
      icon: Mail,
      path: '/outreach',
      active: location.pathname.startsWith('/outreach'),
      adminOnly: true,
    },
    {
      name: 'Social Studio',
      icon: Share2,
      path: '/social-studio',
      active: location.pathname.startsWith('/social-studio'),
      adminOnly: true,
    },
    {
      name: 'Nastavení',
      icon: Settings,
      path: '/settings',
      active: location.pathname.startsWith('/settings'),
    },
  ]

  return (
    <div className={`bg-gray-50 border-r border-gray-200 transition-all duration-300 ${collapsed ? 'w-16' : 'w-64'}`}>
      <div className="flex flex-col h-full">
        {/* Header with user info and collapse button */}
        <div className="p-4 border-b border-gray-200 bg-white">
          <div className="flex items-center justify-between">
            {!collapsed && (
              <div className="flex items-center space-x-3 space-y-3">
                <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center">
                  <User className="w-5 h-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">{user?.username || 'User'}</p>
                  <p className="text-xs text-gray-500 truncate">Admin</p>
                </div>
              </div>
            )}
            <button onClick={onToggleCollapse} className="p-1 rounded-md hover:bg-gray-100 text-gray-500 hover:text-gray-700">
              {collapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-3">
          <ul className="space-y-2">
            {navigationItems.filter((item) => !item.adminOnly || isAdminUser(user)).map((item) => {
              const Icon = item.icon
              return (
                <li key={item.name}>
                  <button
                    onClick={() => navigate(item.path)}
                    className={`w-full flex items-center px-3 py-3 text-sm font-medium rounded-lg transition-all duration-200 ${
                      item.active ? 'bg-purple-100 text-purple-700 border border-purple-100' : 'text-gray-600 hover:bg-white hover:text-gray-900'
                    }`}
                  >
                    <Icon className={`w-5 h-5 flex-shrink-0 ${item.active ? 'text-purple-600' : 'text-gray-500'}`} />
                    {!collapsed && <span className="ml-3 truncate">{item.name}</span>}
                  </button>
                </li>
              )
            })}
          </ul>
        </nav>

        {/* Footer */}
        {!collapsed && (
          <div className="p-4 border-t border-gray-200 bg-white">
            <div className="text-xs text-gray-500">© 2025 Realitní Jestřáb</div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Sidebar
